module.exports = __webpack_public_path__ + "static/mi_grad_mobile-fbbc21612319d8c2e7f016476077deac.svg";